import API_BASE_URL from "./config";
import React, {
  useState,
  useEffect
} from "react";

import axios from "axios";

function FilePicker({
  onSourceSelect,
  onDestinationSelect
}) {

  // =========================================
  // 🔥 COMMON
  // =========================================
  const [folders, setFolders] =
    useState([]);

  // =========================================
  // 🔥 SOURCE TYPE
  // =========================================
  const [sourceType, setSourceType] =
    useState("onedrive");

  // =========================================
  // 🔥 SOURCE ONEDRIVE
  // =========================================
  const [sourceFolderId, setSourceFolderId] =
    useState("");

  const [sourceFiles, setSourceFiles] =
    useState([]);

  const [sourceFileId, setSourceFileId] =
    useState("");

  const [sourceSheets, setSourceSheets] =
    useState([]);

  const [selectedSheets, setSelectedSheets] =
    useState([]);

  // =========================================
  // 🔥 SOURCE GOOGLE SHEETS
  // =========================================
  const [sourceGsheetUrl, setSourceGsheetUrl] =
    useState("");

  const [sourceGsheetName, setSourceGsheetName] =
    useState("");

  // =========================================
  // 🔥 DESTINATION TYPE
  // =========================================
  const [destinationType, setDestinationType] =
    useState("onedrive");

  // =========================================
  // 🔥 DESTINATION ONEDRIVE
  // =========================================
  const [destFolderId, setDestFolderId] =
    useState("");

  const [destFiles, setDestFiles] =
    useState([]);

  const [destFileId, setDestFileId] =
    useState("");

  const [destSheets, setDestSheets] =
    useState([]);

  const [selectedDestSheet, setSelectedDestSheet] =
    useState("");

  // =========================================
  // 🔥 DESTINATION GOOGLE SHEETS
  // =========================================
  const [destGsheetUrl, setDestGsheetUrl] =
    useState("");

  const [destGsheetName, setDestGsheetName] =
    useState("");

  // =========================================
  // 🔥 DESTINATION COLUMNS
  // =========================================
  const [destColumns, setDestColumns] =
    useState([]);

  // =========================================
  // 🔥 LOAD ROOT FOLDERS
  // =========================================
  useEffect(() => {

    axios
      .get(
        `${API_BASE_URL}/files`
      )

      .then((res) => {

        const data =
          res.data.value || [];

        const folderList =
          data.filter(
            (item) => item.folder
          );

        setFolders(folderList);
      })

      .catch((err) =>
        console.error(err)
      );

  }, []);

  // =========================================
  // 🔥 LOAD SOURCE FILES
  // =========================================
  const handleSourceFolder =
    async (e) => {

      const id =
        e.target.value;

      setSourceFolderId(id);

      setSourceFileId("");

      setSourceSheets([]);

      setSelectedSheets([]);

      if (!id) return;

      const res =
        await axios.get(
          `${API_BASE_URL}/files?folder_id=${id}`
        );

      const files =
        (res.data.value || []).filter(
          (f) =>
            !f.folder &&
            (
              f.name.endsWith(".xlsx") ||
              f.name.endsWith(".csv")
            )
        );

      setSourceFiles(files);
    };

  // =========================================
  // 🔥 LOAD DESTINATION FILES
  // =========================================
  const handleDestFolder =
    async (e) => {

      const id =
        e.target.value;

      setDestFolderId(id);

      setDestFileId("");

      setDestSheets([]);

      setSelectedDestSheet("");

      setDestColumns([]);

      if (!id) return;

      const res =
        await axios.get(
          `${API_BASE_URL}/files?folder_id=${id}`
        );

      const files =
        (res.data.value || []).filter(
          (f) =>
            !f.folder &&
            (
              f.name.endsWith(".xlsx") ||
              f.name.endsWith(".csv")
            )
        );

      setDestFiles(files);
    };

  // =========================================
  // 🔥 LOAD SOURCE SHEETS
  // =========================================
  const handleSourceFile =
    async (e) => {

      const id =
        e.target.value;

      setSourceFileId(id);

      setSelectedSheets([]);

      if (!id) return;

      const res =
        await axios.get(
          `${API_BASE_URL}/sheets/${id}`
        );

      setSourceSheets(
        res.data.sheets || []
      );
    };

  // =========================================
  // 🔥 LOAD DESTINATION SHEETS
  // =========================================
  const handleDestFile =
    async (e) => {

      const id =
        e.target.value;

      setDestFileId(id);

      setSelectedDestSheet("");

      setDestColumns([]);

      if (!id) return;

      const res =
        await axios.get(
          `${API_BASE_URL}/sheets/${id}`
        );

      setDestSheets(
        res.data.sheets || []
      );
    };

  // =========================================
  // 🔥 LOAD DESTINATION COLUMNS
  // =========================================
  const loadDestinationColumns =
    async (
      fileId,
      sheetName
    ) => {

      try {

        const res =
          await axios.get(
            `${API_BASE_URL}/sheet-columns/${fileId}/${sheetName}`
          );

        const columns =
          res.data.columns || [];

        setDestColumns(columns);

        onDestinationSelect({

          destination_type:
            "onedrive",

          file_id:
            fileId,

          sheet:
            sheetName,

          columns:
            columns
        });

      } catch (err) {

        console.error(
          "Column load failed",
          err
        );
      }
    };

  // =========================================
  // 🔥 TOGGLE SOURCE SHEETS
  // =========================================
  const toggleSheet =
    (sheet) => {

      if (
        selectedSheets.includes(sheet)
      ) {

        setSelectedSheets(
          selectedSheets.filter(
            (s) => s !== sheet
          )
        );

      } else {

        setSelectedSheets([
          ...selectedSheets,
          sheet
        ]);
      }
    };

  // =========================================
  // 🔥 SEND SOURCE
  // =========================================
  useEffect(() => {

    // =========================================
    // 🔥 ONEDRIVE
    // =========================================
    if (
      sourceType === "onedrive" &&
      sourceFileId &&
      selectedSheets.length > 0
    ) {

      onSourceSelect({

        source_type:
          "onedrive",

        file_id:
          sourceFileId,

        sheets:
          selectedSheets,
      });
    }

    // =========================================
    // 🔥 GOOGLE SHEETS
    // =========================================
    if (
      sourceType === "google_sheets" &&
      sourceGsheetUrl &&
      sourceGsheetName
    ) {

      onSourceSelect({

        source_type:
          "google_sheets",

        gsheet_url:
          sourceGsheetUrl,

        gsheet_name:
          sourceGsheetName
      });
    }

  }, [

    sourceType,

    sourceFileId,

    selectedSheets,

    sourceGsheetUrl,

    sourceGsheetName
  ]);

  // =========================================
  // 🔥 SEND DESTINATION
  // =========================================
  useEffect(() => {

    // =========================================
    // 🔥 ONEDRIVE
    // =========================================
    if (
      destinationType === "onedrive" &&
      destFileId &&
      selectedDestSheet
    ) {

      loadDestinationColumns(
        destFileId,
        selectedDestSheet
      );
    }

    // =========================================
    // 🔥 GOOGLE SHEETS
    // =========================================
    if (
      destinationType === "google_sheets" &&
      destGsheetUrl &&
      destGsheetName
    ) {

      onDestinationSelect({

        destination_type:
          "google_sheets",

        gsheet_url:
          destGsheetUrl,

        gsheet_name:
          destGsheetName,

        columns: []
      });
    }

  }, [

    destinationType,

    destFileId,

    selectedDestSheet,

    destGsheetUrl,

    destGsheetName
  ]);

  return (
    <div>

      {/* ========================================= */}
      {/* 🔥 SOURCE */}
      {/* ========================================= */}
      <div className="section-title">
        Source
      </div>

      {/* SOURCE TYPE */}
      <label>
        Source Type
      </label>

      <select
        className="dropdown"
        value={sourceType}
        onChange={(e) =>
          setSourceType(
            e.target.value
          )
        }
      >

        <option value="onedrive">
          OneDrive
        </option>

        <option value="google_sheets">
          Google Sheets
        </option>

      </select>

      {/* ========================================= */}
      {/* 🔥 SOURCE ONEDRIVE */}
      {/* ========================================= */}
      {sourceType ===
        "onedrive" && (
        <>

          <select
            className="dropdown"
            value={sourceFolderId}
            onChange={handleSourceFolder}
          >

            <option value="">
              Select Folder
            </option>

            {folders.map((f) => (

              <option
                key={f.id}
                value={f.id}
              >
                {f.name}
              </option>

            ))}

          </select>

          <select
            className="dropdown"
            value={sourceFileId}
            onChange={handleSourceFile}
          >

            <option value="">
              Select File
            </option>

            {sourceFiles.map((f) => (

              <option
                key={f.id}
                value={f.id}
              >
                {f.name}
              </option>

            ))}

          </select>

          {/* SOURCE SHEETS */}
          {sourceSheets.length > 0 && (

            <div className="sheet-section">

              <div className="sheet-grid">

                {sourceSheets.map((sheet) => (

                  <label
                    key={sheet}
                    className="sheet-item"
                  >

                    <input
                      type="checkbox"
                      checked={selectedSheets.includes(sheet)}
                      onChange={() =>
                        toggleSheet(sheet)
                      }
                    />

                    {sheet}

                  </label>

                ))}

              </div>

            </div>
          )}

        </>
      )}

      {/* ========================================= */}
      {/* 🔥 SOURCE GOOGLE SHEETS */}
      {/* ========================================= */}
      {sourceType ===
        "google_sheets" && (
        <>

          <input
            type="text"
            className="dropdown"
            placeholder="Paste Google Sheet URL"
            value={sourceGsheetUrl}
            onChange={(e) =>
              setSourceGsheetUrl(
                e.target.value
              )
            }
          />

          <input
            type="text"
            className="dropdown"
            placeholder="Sheet Name"
            value={sourceGsheetName}
            onChange={(e) =>
              setSourceGsheetName(
                e.target.value
              )
            }
          />

        </>
      )}

      {/* ========================================= */}
      {/* 🔥 DESTINATION */}
      {/* ========================================= */}
      <div
        className="section-title"
        style={{
          marginTop: "25px"
        }}
      >
        Destination
      </div>

      {/* DEST TYPE */}
      <label>
        Destination Type
      </label>

      <select
        className="dropdown"
        value={destinationType}
        onChange={(e) =>
          setDestinationType(
            e.target.value
          )
        }
      >

        <option value="onedrive">
          OneDrive
        </option>

        <option value="google_sheets">
          Google Sheets
        </option>

      </select>

      {/* ========================================= */}
      {/* 🔥 DESTINATION ONEDRIVE */}
      {/* ========================================= */}
      {destinationType ===
        "onedrive" && (
        <>

          <select
            className="dropdown"
            value={destFolderId}
            onChange={handleDestFolder}
          >

            <option value="">
              Select Folder
            </option>

            {folders.map((f) => (

              <option
                key={f.id}
                value={f.id}
              >
                {f.name}
              </option>

            ))}

          </select>

          <select
            className="dropdown"
            value={destFileId}
            onChange={handleDestFile}
          >

            <option value="">
              Select File
            </option>

            {destFiles.map((f) => (

              <option
                key={f.id}
                value={f.id}
              >
                {f.name}
              </option>

            ))}

          </select>

          {/* DEST SHEETS */}
          {destSheets.length > 0 && (

            <div className="sheet-section">

              <div className="sheet-grid">

                {destSheets.map((sheet) => (

                  <label
                    key={sheet}
                    className="sheet-item"
                  >

                    <input
                      type="radio"
                      name="destination"
                      checked={
                        selectedDestSheet === sheet
                      }
                      onChange={() =>
                        setSelectedDestSheet(sheet)
                      }
                    />

                    {sheet}

                  </label>

                ))}

              </div>

            </div>
          )}

        </>
      )}

      {/* ========================================= */}
      {/* 🔥 DESTINATION GOOGLE SHEETS */}
      {/* ========================================= */}
      {destinationType ===
        "google_sheets" && (
        <>

          <input
            type="text"
            className="dropdown"
            placeholder="Paste Google Sheet URL"
            value={destGsheetUrl}
            onChange={(e) =>
              setDestGsheetUrl(
                e.target.value
              )
            }
          />

          <input
            type="text"
            className="dropdown"
            placeholder="Sheet Name"
            value={destGsheetName}
            onChange={(e) =>
              setDestGsheetName(
                e.target.value
              )
            }
          />

        </>
      )}

    </div>
  );
}

export default FilePicker;